import { TertiaryButton } from '@changegps/horizon-component-library';
import { Box, Stack, Typography } from '@mui/material';

import { ProductKeys, useUserHasProductsAccess } from '@/features/users';

import { EXPLORE_CONTENT } from '../constants/content';

import { Card } from './Card';
import { HomeLayout } from './HomeLayout';

export const ExploreChangeGPS = () => {
  const userHasAccess = useUserHasProductsAccess();

  const checkForProductAccess = (product: string) => {
    let processedProduct: string = product.toLowerCase().replace(/\s+/g, '');

    if (processedProduct.substring(0, 4) === 'core') processedProduct = 'core';

    return userHasAccess[processedProduct as ProductKeys];
  };

  return (
    <HomeLayout title="Explore ChangeGPS">
      {EXPLORE_CONTENT.map((item) => (
        <Box key={item.title} mb={1}>
          <Card>
            <Stack direction="row">
              <Box
                sx={{
                  backgroundColor: '#73808B',
                  width: 32,
                  height: 32,
                  borderRadius: 1,
                  flexShrink: 0,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                {item.icon}
              </Box>

              <Box sx={{ width: 16 }} />

              <Stack>
                <Typography sx={{ fontWeight: 500, fontSize: 18, mb: 2 }}>
                  {item.title}
                </Typography>

                <Typography sx={{ fontWeight: 400, fontSize: 13, mb: 1 }}>
                  {item.description}
                </Typography>

                <Stack direction="row" flexWrap="wrap" gap={1}>
                  {item.tags?.map((tag) => (
                    <TertiaryButton
                      key={tag.label}
                      disabled={!checkForProductAccess(tag.label)}
                      onClick={() => {
                        if (!checkForProductAccess(tag.label)) return;
                        window.location.href = tag.to as string;
                      }}
                    >
                      {tag.label}
                    </TertiaryButton>
                  ))}
                </Stack>
              </Stack>
            </Stack>
          </Card>
        </Box>
      ))}
    </HomeLayout>
  );
};
